import { Dialog, Transition } from '@headlessui/react'
import { Fragment, SyntheticEvent, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../features/auth/authSlice'
import { SuccessIcon } from '../../../shared/SuccessIcon'

export const BasicInfo = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false)

  const user = useSelector(selectCurrentUser)

  return (
    <div className='w-full max-w-lg mx-auto md:py-12 px-4'>
      <form action='' onSubmit={(e: SyntheticEvent) => e.preventDefault()}>
        <div className='flex flex-col gap-2 mt-8'>
          <label htmlFor='name' className='text-xs text-white/70'>
            Name
          </label>
          <input
            id='name'
            name='name'
            type='text'
            value={user?.name}
            placeholder='John Doe'
            className='form-input'
          />
        </div>

        <div className='flex flex-col gap-2 mt-4'>
          <label htmlFor='phone' className='text-xs text-white/70'>
            Phone Number
          </label>
          <input
            type='number'
            name='phone'
            id='phone'
            value={user?.phoneNumber}
            placeholder='07XXXXXXXX'
            className='form-input spin-button-none'
          />
        </div>

        <div className='flex flex-col gap-2 mt-4'>
          <label htmlFor='email' className='text-xs text-white/70'>
            Email Address
          </label>
          <input
            id='email'
            name='email'
            type='email'
            value={user?.email}
            placeholder='johndoe@mail.com'
            className='form-input'
          />
        </div>

        <button
          type='submit'
          className='btn-primary px-4 py-2 rounded-full w-full text-base mx-auto mt-8 disabled:bg-zinc-500 disabled:text-zinc-400 disabled:cursor-not-allowed'
          onClick={() => setIsSuccessModalOpen(true)}
          disabled
        >
          Update basic info
        </button>

        <Transition appear show={isSuccessModalOpen} as={Fragment}>
          <Dialog
            as='div'
            className='relative z-50'
            onClose={() => setIsSuccessModalOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <div className='fixed inset-0 bg-black/40 backdrop-blur-sm' />
            </Transition.Child>

            <div className='fixed inset-0 overflow-y-auto'>
              <div className='flex min-h-full items-center justify-center p-4 text-center'>
                <Transition.Child
                  as={Fragment}
                  enter='ease-out duration-300'
                  enterFrom='opacity-0 scale-95'
                  enterTo='opacity-100 scale-100'
                  leave='ease-in duration-200'
                  leaveFrom='opacity-100 scale-100'
                  leaveTo='opacity-0 scale-95'
                >
                  <Dialog.Panel className='relative font-dashboard w-full max-w-3xl min-h-[500px] transform overflow-hidden rounded-2xl bg-[#161819] px-4 pt-4 pb-10 text-left align-middle shadow-xl transition-all'>
                    <div className='relative py-24 flex flex-col items-center'>
                      <div className='flex flex-col items-center gap-4'>
                        <SuccessIcon />
                        <p className='text-xl font-light text-white/40'>
                          Basic info updated
                        </p>
                      </div>

                      <button
                        className='btn-primary py-2 rounded-lg w-full max-w-md mt-12'
                        onClick={() => {
                          setIsSuccessModalOpen(false)
                        }}
                      >
                        Done
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </form>
    </div>
  )
}
